module.exports = __webpack_public_path__ + "img/layout4.473499b6.png";